export default "/images/voyager.png";